import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Typography from "material-ui-next/Typography";

import styles from "../styles";
import { DescriptionField } from "components/support";
import Icon from "material-ui-next/Icon";

class CompanyIntegrationsNappView extends Component {
  onEnabledChange(napp) {
    if (napp) {
      return (
        <div style={styles.informations}>
          <div>
            <Icon style={styles.enabledIconTrue}>done</Icon>
          </div>
          <div style={styles.message}>Integração Ativa</div>
        </div>
      );
    } else {
      return (
        <div style={styles.informations}>
          <div>
            <Icon style={styles.enabledIconFalse}>close</Icon>
          </div>
          <div style={styles.message}>Integração Inativa</div>
        </div>
      );
    }
  }

  render() {
    const { company } = this.props;
    const integrations = company.integrations || {};
    const napp = integrations.napp || {};

    return (
      <div className="grid-container">
        <Row>
          <Col xs={12}>
            <div className="grid-container mt-sm mb-sm">
              <Typography type="headline">Napp</Typography>
              <hr />
              <Row>
                <Col xs={12}>
                  <DescriptionField label="URL" value={napp.url} />
                </Col>
              </Row>
              <Row>
                <Col xs={12} lg={6}>
                  <DescriptionField label="Login" value={napp.user} />
                </Col>
                <Col xs={12} lg={6}>
                  <DescriptionField
                    type="password"
                    label="Senha"
                    value={napp.password}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} lg={6}>
                  <DescriptionField label="ID da Empresa" value={napp.id} />
                </Col>
                <Col xs={12} lg={6}>
                  <DescriptionField label="Nome da Empresa" value={napp.name} />
                </Col>
              </Row>
              <Row>{this.onEnabledChange(napp.enabled)}</Row>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default CompanyIntegrationsNappView;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/view/integrations/napp/index.jsx